import { useQuery } from "@tanstack/react-query";
import { checkPremiumAccess, getSubscriptionTier } from "@/utils/subscriptionCheck";
import { useAuth } from "@/contexts/AuthContext";

export const usePremiumAccess = () => {
  const { user } = useAuth();

  const { data: hasPremium, isLoading: isLoadingPremium } = useQuery({
    queryKey: ["premium-access", user?.id],
    queryFn: () => checkPremiumAccess(user!.id),
    enabled: !!user,
  });

  const { data: tier, isLoading: isLoadingTier } = useQuery({
    queryKey: ["subscription-tier", user?.id],
    queryFn: () => getSubscriptionTier(user!.id),
    enabled: !!user,
  });

  return {
    hasPremium: hasPremium || false,
    tier: tier || 'free',
    isLoading: isLoadingPremium || isLoadingTier,
  };
};
